//import angular from 'angular';

/**
 * printDiv
 */
angular.module('relivConference').directive(
    'printDiv',
    [
        'relivConferenceBadgePrintService',
        function (
            relivConferenceBadgePrintService
        ) {
            return {
                scope: {
                    printTicket: '=',
                    btnClass: '=',
                    btnDisabled: '=',
                    btnLabel: '=',
                },
                link: function (scope, element) {
                    scope.handleClick = function () {
                        relivConferenceBadgePrintService.printElem(scope.printTicket);
                    };
                },

                template: `
                    <button
                        class="{{btnClass}}"
                        ng-click="handleClick()"
                        ng-disabled="btnDisabled"
                    >
                        {{btnLabel}}
                    </button>
                `,
            };
        },
    ]
);
